<!-- src/views/DashboardView.vue -->
<template>
  <div class="dashboard-content">
    <div class="view-mode-actions">
      <router-link to="/dashboard-shell" class="mode-switch-btn">
        Abrir modo portal + widget
      </router-link>
    </div>
    <chat-bot-component />
  </div>
</template>

<script>
import ChatBotComponent from '@/components/ChatBotComponent.vue'

export default {
  name: 'DashboardView',
  components: {
    ChatBotComponent
  }
}
</script>

<style scoped>
.dashboard-content {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
}

.view-mode-actions {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 12px;
}

.mode-switch-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  background: #1e4d8c;
  color: #ffffff;
  padding: 8px 14px;
  font-size: 12px;
  font-weight: 700;
  text-decoration: none;
  letter-spacing: 0.01em;
}

.mode-switch-btn:hover {
  background: #173b6b;
}
</style>
